import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'

import { resolveWordPressPathForGatsby } from '../../utils'
import './Footer.css'

const footerMenuQuery = graphql`
  query FooterWordpressPages {
    allWordpressPage(
      filter: { status: { eq: "publish" } }
      sort: { fields: [title], order: ASC }
    ) {
      edges {
        node {
          id
          title
          path
        }
      }
    }
  }
`

const homeItem = { id: 'footer-home', title: 'Accueil', url: '/' }

const Footer = () => {
  const data = useStaticQuery(footerMenuQuery)

  const wpLinks = (data.allWordpressPage && data.allWordpressPage.edges ? data.allWordpressPage.edges : []).map(
    ({ node }) => ({
      id: node.id,
      title: node.title || '',
      url: resolveWordPressPathForGatsby(node.path),
    })
  )

  const footerLinks = [homeItem, ...wpLinks.filter(item => item.url !== '/')]

  return (
    <footer className="footer">
      <div className="container container--fluid">
        <ul>
          {footerLinks.map(item => (
            <li key={item.id}>
              <Link to={item.url}>{item.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  )
}

export default Footer
